module.exports = __webpack_public_path__ + "assets/img/teacher (16).26ba9b37.png";